export default "__VITE_ASSET__BFnLnCgL__"